import { makeRequest } from 'utils/requestLogger';

export default (courseID, feedbackID) =>
  makeRequest(
    'delete',
    `/api/courses/${courseID}/remove-feedback/${feedbackID}`
  );



// WEBPACK FOOTER //
// ./src/app/services/courses/deleteFeedback.js